import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';

const Portfolio = () => {
    const { t } = useTranslation();

    return (
        <div className="portfolio-container">
            <SEO
                title={t('portfolio_page_title')}
                description={`${t('portfolio_page_title')}. Tparan.am portfolio.`}
            />
            <div>
                <a href="https://instagram.com/tparan.am" style={{ position: "relative", textAlign: "center" }}>
                    <div className="more_link">{t('portfolio_more')}</div>
                    <img style={{ opacity: "0" }}
                        width="250px"
                        height="250px"
                        className="portfolio-img more"
                        alt=""
                    />
                    <span className="more_link">{t('portfolio_more')}</span>
                </a>
            </div>
        </div>
    );
};

export default Portfolio;